export function shuffle<T>(array: Array<T>): Array<T> {
  array = array.map((item) => item);
  for (let i = 0; i < array.length; i++) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

export function sample<T>(array: Array<T>, size: number): Array<T> {
  array = shuffle(array);
  return array.slice(0, size);
}
